import { useApi } from '@/api/useApi.ts';
import {
    IEuropeanIndexDataPayload, IIndexDataPayload, IFreeIndexDataPayload, ICreateEuroIndexPayload,
    IDefaultIndexPayload,
    IPlantIndexPayload,
    ISkipRateDataPayload,
} from '@/interfaces/benchmarks/index/IIndexDataPayload.ts';
import { IGbIndexPrepared, IEuropeanIndex } from '@/interfaces/benchmarks/index/IIndex.ts';
import {
    ICreateEuroIndexResponse, IIndexCountryConfiguration, IIndexDataReturnObject, IPlantIndexReturnObject,
} from '@/interfaces/benchmarks/index/IIndexDataResponse.ts';

const seriesApi = useApi('series');

async function getIndexData (payload: IIndexDataPayload): Promise<IIndexDataReturnObject> {
    const response = await seriesApi.post<IIndexDataPayload, IIndexDataReturnObject>({
        endpoint: '/IndexApi',
        payload,
    });
    return response.data;
}

async function getSkipRatesData (payload: ISkipRateDataPayload): Promise<IIndexDataReturnObject> {
    const response = await seriesApi.post<ISkipRateDataPayload, IIndexDataReturnObject>({
        endpoint: '/SkipRatesApi',
        payload,
    });

    return response.data;
}

async function getLongTermIndexFree (payload: IFreeIndexDataPayload): Promise<IIndexDataReturnObject> {
    const response = await seriesApi.post<IFreeIndexDataPayload, IIndexDataReturnObject>({
        endpoint: '/LongTermForecastFreeIndex',
        payload,
    });
    return response.data;
}

async function getEuropeIndexData (payload: IEuropeanIndexDataPayload): Promise<IIndexDataReturnObject> {
    const response = await seriesApi.post<IEuropeanIndexDataPayload, IIndexDataReturnObject>({
        endpoint: '/EuropeIndexApi/getData',
        payload,
    });
    return response.data;
}

async function getDefaultEuropeIndexData (payload: IDefaultIndexPayload): Promise<Record<string, IEuropeanIndex>> {
    const response = await seriesApi.post<IDefaultIndexPayload, Record<string, IEuropeanIndex>>({
        endpoint: '/EuropeIndexApi/defaultIndices',
        payload,
    });
    return response.data;
}

async function createEuropeIndex (payload: ICreateEuroIndexPayload): Promise<ICreateEuroIndexResponse> {
    const response = await seriesApi.post<ICreateEuroIndexPayload, ICreateEuroIndexResponse>({
        endpoint: '/EuropeIndexApi/createIndex',
        payload,
    });
    return response.data;
}

async function getAllPlantsInIndex (payload: IPlantIndexPayload): Promise<IPlantIndexReturnObject> {
    const response = await seriesApi.post<IPlantIndexPayload, IPlantIndexReturnObject>({
        endpoint: '/GetAllPlantsInIndex',
        payload,
    });
    return response.data;
}

async function getGbIndexId (payload: IGbIndexPrepared): Promise<string> {
    const response = await seriesApi.post<IGbIndexPrepared, string>({
        endpoint: '/GbIndexId',
        payload,
    });
    return response.data;
}

async function getEuroIndexId (payload: ICreateEuroIndexPayload): Promise<string> {
    const response = await seriesApi.post<ICreateEuroIndexPayload, string>({
        endpoint: '/EuropeIndexId',
        payload,
    });
    return response.data;
}

async function getAllIndexCountryConfigurations (): Promise<Array<IIndexCountryConfiguration>> {
    const response = await seriesApi.get<Array<IIndexCountryConfiguration>>({
        endpoint: '/EuropeIndexApi/GetAllIndexCountryConfigurations',
    });
    return response.data;
}

export const indexApi = {
    getIndexData,
    getSkipRatesData,
    getAllPlantsInIndex,
    getEuropeIndexData,
    getDefaultEuropeIndexData,
    createEuropeIndex,
    getLongTermIndexFree,
    getGbIndexId,
    getEuroIndexId,
    getAllIndexCountryConfigurations,
};
